// extracted by mini-css-extract-plugin
module.exports = {"ctrComp":"SearchResultSection_ctrComp__1p-LJ"};